module.exports = __webpack_public_path__ + "public/img/bg_04.dd3de9aa.png";